(() => {
  if (!customElements.get('auyol-card-rating')) {
    class CardRating extends HTMLElement {
      connectedCallback() {
        const source = this.querySelector('.auyol-card-rating__source');
        if (!source) return;
        const update = () => {
          const badge = source.querySelector('[data-average-rating], [data-rating], [data-review-avg]');
          if (!badge) return;
          const score = Math.min(5, Math.max(0, Number(badge.dataset.averageRating || badge.dataset.rating || badge.dataset.reviewAvg) || 0));
          const count = Math.max(0, parseInt(String(badge.dataset.numberOfReviews || badge.dataset.raters || badge.dataset.reviewCount || '0').replace(/,/g, ''), 10) || 0);
          this.querySelector('[data-rating-score]').textContent = score.toFixed(1);
          this.querySelector('[data-rating-count]').textContent = '(' + count.toLocaleString(document.documentElement.lang || 'en') + ')';
          this.querySelector('[data-rating-fill]').style.width = (score / 5 * 100) + '%';
          const link = this.querySelector('a');
          link.setAttribute('aria-label', score.toFixed(1) + ' / 5 (' + count + ')');
        };
        update();
        this.observer = new MutationObserver(update);
        this.observer.observe(source, {childList:true, subtree:true, attributes:true});
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    }
    customElements.define('auyol-card-rating', CardRating);
  }
  if (!customElements.get('auyol-card-options')) {
    class CardOptions extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.card = this.closest('.m-product-card');
        this.variants = JSON.parse(this.querySelector('[data-card-variants]').textContent);
        this.addEventListener('click', event => {
          const button = event.target.closest('.auyol-card-options__swatch');
          if (button) this.select(button);
        });
        this.addEventListener('keydown', event => {
          const button = event.target.closest('.auyol-card-options__swatch');
          if (!button || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const buttons = [...button.parentElement.querySelectorAll('button')];
          let index = buttons.indexOf(button);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = buttons.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[index].focus();
          this.select(buttons[index]);
        });
      }
      select(button) {
        const row = button.closest('[data-option-row]');
        row.querySelectorAll('button').forEach(node => node.setAttribute('aria-pressed', String(node === button)));
        row.querySelector('[data-option-label]').textContent = button.dataset.value;
        const options = [...this.querySelectorAll('[data-option-row]')].map(node => node.querySelector('[aria-pressed="true"]')?.dataset.value);
        const variant = this.variants.find(item => item.options.every((value, index) => value === options[index]));
        if (!variant) return;
        const card = this.card;
        card.querySelectorAll('[name="id"]').forEach(input => { if (!input.closest('[data-auyol-variant-form]')) { input.value = variant.id; input.setAttribute('value', variant.id); } });
        card.querySelectorAll('.m-product-card__name,.m-product-card__link').forEach(link => link.href = variant.url);
        const rating = card.querySelector('.auyol-card-rating__link');
        if (rating) rating.href = variant.url + '#judgeme_product_reviews';
        const image = card.querySelector('.m-product-card__main-image img');
        if (image && variant.image) {
          image.src = variant.image;
          image.removeAttribute('srcset');
        }
        card.classList.add('auyol-card--variant-selected');
        const price = card.querySelector('.m-price');
        price?.classList.toggle('m-price--on-sale', variant.compare > variant.price);
        card.querySelectorAll('.m-price__regular .m-price-item--regular').forEach(node => node.innerHTML = variant.money);
        card.querySelectorAll('.m-price-item--sale').forEach(node => node.innerHTML = variant.money);
        card.querySelectorAll('.m-price__sale s').forEach(node => node.innerHTML = variant.compareMoney);
        const sale = card.querySelector('.m-product-tag--sale');
        if (sale) {
          sale.classList.toggle('!m:hidden', variant.compare <= variant.price);
          if (variant.compare > variant.price) sale.textContent = Math.round((variant.compare-variant.price)/variant.compare*100) + '% ' + (card.dataset.savingsLabel || 'SAVINGS');
        }
        const soldout = card.querySelector('.m-product-tag--soldout');
        if (soldout) soldout.style.display = variant.available ? 'none' : 'flex';
        card.querySelectorAll('button.m-add-to-cart').forEach(node => { if (!node.closest('[data-auyol-variant-form]')) node.disabled = !variant.available; });
        card.dispatchEvent(new CustomEvent('auyol:card-variant-change', {bubbles:true, detail:{variant}}));
      }
    }
    customElements.define('auyol-card-options', CardOptions);
  }
})();
